import { StarIcon } from "@heroicons/react/24/outline";
import { cva } from "class-variance-authority";
import { useMemo } from "react";
import { TooltipItem } from "src/utils/Tooltip";
import { twMerge } from "tailwind-merge";

const favoriteButtonStyle = cva("block", {
  variants: {
    active: {
      true: "text-[#F2A900] fill-current",
      false: "text-[#9CA3AF]"
    },
    disabled: {
      true: "opacity-50 cursor-not-allowed",
      false: ""
    }
  },
  defaultVariants: {
    active: false,
    disabled: false
  }
});

function FavoriteButton({
  isFavorite,
  onToggle,
  disabled = false,
  position = "left"
}: {
  isFavorite: { state: boolean; id: number | null };
  onToggle: () => void;
  disabled?: boolean;
  position?: "right" | "top" | "left" | "bottom" | "top-right" | "top-left" | "bottom-right" | "bottom-left";
}) {
  const tooltipText = useMemo(() => {
    return isFavorite.state ? "Удалить из избранного" : disabled ? "Нет фильтров" : "Добавить в избранное";
  }, [isFavorite.state, disabled]);

  return (
    <button disabled={disabled} onClick={onToggle} className="w-6 h-6">
      <TooltipItem position={position} tooltipsText={tooltipText} wrapperClassName={"hover:active-svg"}>
        <StarIcon width={24} height={24} className={twMerge(favoriteButtonStyle({ active: isFavorite.state, disabled: disabled }))} />
      </TooltipItem>
    </button>
  );
}

export default FavoriteButton;
